import React from 'react';
import api from '../../../helpers/api';

import styles from './ProductFamily.module.scss';
import Loader from '../../miscellaneous/Loader/Loader';
import {$t} from '../../../helpers/translator';
import Modal from '../../miscellaneous/Modal/Modal';

import _ from "lodash";
import ContactDistributor from "../ContactDistributor/ContactDistributor";

class ProductFamily extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            products: null,

            showContactDistributorModal: false,
            productSelected: null
        };
    }

    async componentDidMount() {
        try {
            let res = await api.get('/general/equipment');

            if (res && res.data.data) {
                _.forEach(res.data.data, (v, k) => {
                    if (v.name === 'Soprano Titanium') {
                        res.data.data.splice(k, 1);
                        res.data.data.unshift(v);
                    }
                });

                this.setState({products: res.data.data}, () => {
                    // console.log(this.state);
                });
            }
        } catch (e) {
            console.error('err getting product family', e);
        }
    }

    closeModals() {
        this.setState({
            productSelected: null,
            // productSelected: null
        });
    }

    contactDistributorSuccessHandler() {
        // this.setState()
    }

    render() {
        return (
            <div className={'alma-box'}>
                <div className={'alma-box-header'}>
                    <span><h3>{$t('global.service.almaProductFamily')}</h3></span>
                </div>
                <div>
                    {this.state.products ?
                        <div className={`${styles['products-container']}`}>
                            {this.state.products.map((v, k) => (
                                <div className={`${styles['product']}`} key={k} onClick={() => this.setState({productSelected: v})}>
                                    <div className={`${styles['image-container']}`} style={{
                                        background: 'url(\'' + v.image + '\') 50% 0% no-repeat',
                                        'backgroundSize': 'contain',
                                    }}>
                                    </div>
                                    <div className={`${styles['name-container']}`}>
                                        {v.name}
                                    </div>
                                    <div className={`${styles['hover-layer']}`}>
                                        <div>{$t('global.service.contactDistributor.contactDistributor')}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        :
                        <Loader/>
                    }
                </div>

                <Modal
                    content={<ContactDistributor product={this.state.productSelected}/>}
                    onClose={this.closeModals.bind(this)}
                    visible={this.state.productSelected}/>
            </div>
        );
    }

}

export default ProductFamily;
